import { useState, useEffect } from "react";
import { Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import CountDown from "@/Layouts/components/CountDown";
import AlertWithIcon from "@/Layouts/components/MessagesAlert/AlertWithIcon";
import WarningIcon from "@/Washouts/assets/icons/warningIcon.svg";
import { styled } from "@mui/material/styles";

type CommissionCycleClosingDialogProps = {
	openModal: boolean;
	onCloseCommission?: () => void;
	onCloseDialog?: () => void;
};

const BootstrapDialog = styled(Dialog)(() => ({
	"& .MuiPaper-root": {
		borderRadius: "10px",
	},
}));

export default function CommissionCycleClosingDialog(props: Readonly<CommissionCycleClosingDialogProps>) {
	const { openModal = false, onCloseCommission = () => {}, onCloseDialog = () => {} } = props ?? {};

	const [open, setOpen] = useState(false);
	const [changeButtonType, setChangeButtonType] = useState(false);

	const handleCloseCommission = () => {
		setOpen(false);
		onCloseCommission?.();
	};
	const handleCloseDialog = () => {
		setOpen(false);
		onCloseDialog?.();
	};

	const onTimesUp = () => {
		setChangeButtonType(true);
	};

	useEffect(() => {
		setOpen(openModal);

		return () => {
			setOpen(false);
			setChangeButtonType(false);
		};
	}, [openModal]);

	return (
		<BootstrapDialog
			PaperProps={{ sx: { width: "375px", height: "200px" } }}
			open={open}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title" className="time-out-title">
				{
					<AlertWithIcon
						className="error-message-span bg-transparent"
						text={"Warning"}
						icon={<img className="w-[15px]" src={WarningIcon} alt="warning" />}
						textStyle={{
							color: "#e20000 !important",
							marginLeft: 0.5,
							fontFamily: "Montserrat !important",
							fontWeight: "700",
							fontSize: "16px !important",
						}}
					/>
				}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description" className="time-out-body">
					You are about to{" "}
					<u>
						<b>permanently</b>
					</u>{" "}
					finalize the current Commission Cycle for this month. Please make sure all OEM submissions are complete before
					proceeding. This action <b>cannot</b> be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions className="mb-[10px] mr-[10px]">
				<Grid container className="justify-between">
					<Grid item className="!ml-[15px]">
						<Button variant="outlined" className="!h-[30px] sign-out-btn !bg-gray-blue" onClick={handleCloseDialog}>
							<Typography className="select-plan-dialog-assign-btn-text assign-btn-regular-text !text-white">
								Cancel
							</Typography>
						</Button>
					</Grid>
					<Grid item className="!mr-[15px]">
						{!changeButtonType ? (
							<Button disabled variant="contained" className="!h-[30px] bg-disabled ">
								<Typography className="select-plan-dialog-assign-btn-text !text-white">
									Finalize Commission Cycle {open && <CountDown onTimesUp={onTimesUp} time={30} />}s
								</Typography>
							</Button>
						) : (
							<Button
								onClick={handleCloseCommission}
								variant="contained"
								className={
									"!h-[30px] !rounded-md !shadow-none !bg-primary hover:!shadow-primary-shadow-50 [&.Mui-disabled]:!bg-disabled"
								}
							>
								<Typography className="select-plan-dialog-assign-btn-text">Finalize Commission Cycle</Typography>
							</Button>
						)}
					</Grid>
				</Grid>
			</DialogActions>
		</BootstrapDialog>
	);
}
